<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>首页商品分类设置</h3>
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="handleAdd">新增</el-button>
                </el-col>
            </el-row>
        </div>
        <el-table :data="fetchList" >
            <el-table-column prop="name" label="分类名称">
            </el-table-column>
            <el-table-column inline-template :context="_self" label="分类图片" width="180">
                <img :src="row.picUrl" class="user-pic" />
            </el-table-column>
            <el-table-column inline-template :context="_self" width="150" label="操作">
                <span>
            			    <!-- <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button> -->
            			    <el-button @click="handleDelete($index, row)" type="text" size="small" v-if="Role === '1'">删除</el-button>
            		     </span>
            </el-table-column>
        </el-table>
    
        <div class="page-footer">
            <el-button type="primary" @click="next" size="large">提交</el-button>
        </div>
    
    </div>
</template>

<script>
    import {
        getVersions,
        getGlobalSettings,
        postVersions,
        filterIndexVersions,
        getProductCategories,
        getProductTags,
        getProductDetails,
        putVersions
    } from '../../api/version'
    
    export default {
        data() {
            return {
                fetchList: [],
                Role: sessionStorage.power,
                uptoken: {
                    token: sessionStorage.userId
                }
            }
        },
    
        created() {
            let currentData = this.$store.state.currentIndex
            this.fetchList = currentData.value.category
        },
    
        methods: {
            handleAdd() {
                this.$router.push('/addCategory')
            },
            next() {
                let currentData = this.$store.state.currentIndex
                let upData = JSON.parse(JSON.stringify(currentData))
                delete upData.base
                if (upData.id) {
                    let data = JSON.parse(JSON.stringify(upData))
                    delete data.id 
                    //update
                    putVersions(this.uptoken.token, upData.id, data).then( res => {
                        console.log(res,'xi')
                        if(res.data.version) {
                            this.$message({
                                message: '成功更新版本信息',
                                type: 'success'
                            });
                            this.$router.push('/main')
                        }
                    }, err => {
                        this.$message.error('更新数据失败');
                    })
                } else {
                    postVersions(this.uptoken.token, upData).then(res => {
                        console.log(res.data.data)
                        if (res.data) {
                            this.$message({
                                message: '成功创建首页版本',
                                type: 'success'
                            });
                            this.$router.push('/main')
                        }
                    }, err => {
                        console.log(err)
                        this.$message.error('创建失败，请检查相关数据');
                    })
                }
    
                console.log(currentData)
            },
            handleDelete(index, row) {
				this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    console.log(this.fetchList)
                    console.log(index)
					this.fetchList.splice(index, 1)
					let currentCategory = JSON.parse(JSON.stringify(this.fetchList))
					let currentData = this.$store.state.currentIndex

					currentData.value.category = currentCategory
					this.$store.commit('SETCURRENTINDEX', currentData);
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
					// this.refresh()
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
    
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// IndexCatogrey.vue?c5cf0142